"use strict";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./lit-element"), exports);
__exportStar(require("./decorators"), exports);
// console.warn(
//   "The main 'lit-element' module entrypoint is deprecated. Please update " +
//     "your imports to use the 'lit' package: 'lit' and 'lit/decorators.ts' " +
//     "or import from 'lit-element/lit-element.ts'. See " +
//     'https://lit.dev/msg/deprecated-import-path for more information.'
// );
